import { Link } from "react-router-dom";
function DashboardProjects() {
	return (
		<>
			<div className="row">
				<div className="col-lg-3 col-sm-6">
					<div className="card-box bg-orange">
						<div className="inner">
							<h3>Create Projects</h3>
							<p>Project Create form</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/dashboardprojects/create-project"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>
				<div className="col-lg-3 col-sm-6">
					<div className="card-box bg-orange">
						<div className="inner">
							<h3>Delete Project</h3>
							<p>Project delete</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/dashboardprojects/delete-project"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>

				<div className="col-lg-3 col-sm-6">
					<div className="card-box bg-orange">
						<div className="inner">
							<h3>Create Sub Project</h3>
							<p>Sub Project</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/dashboardprojects/create-sub-project"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>

				<div className="col-lg-3 col-sm-6">
					<div className="card-box bg-orange">
						<div className="inner">
							<h3>Delete Sub Project</h3>
							<p>Delete Sub Project</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/dashboardprojects/delete-sub-project"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}

export default DashboardProjects;
